export const NO_GDS_DATA_AVAILABLE_MESSAGE = 'No data to display for selected dates'
